import React, { SyntheticEvent, useEffect, useState } from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Flex, Icon, Input, UiButton } from '@shared/ui';

import cls from './AddNewAlbum.module.css';

interface AddNewAlbumProps {
    classes?: string;
    value: string;
    addNewTag: (newOption?: string) => void;
}

export const AddNewAlbum = ({ classes, value, addNewTag }: AddNewAlbumProps) => {
    const { t } = useTranslation();

    const [isAdding, setIsAdding] = useState(false);
    const [addAlbumValue, setAddAlbumValue] = useState('');

    const onAddingToggle = () => {
        if (isAdding) {
            setAddAlbumValue('');
        }
        setIsAdding(!isAdding);
    };

    useEffect(() => {
        setAddAlbumValue(value);
    }, [value, isAdding]);

    const onInputChange = (_: string, searchValue: string) => {
        setAddAlbumValue(searchValue);
    };
    return (
        <Flex
            justify="center"
            fullWidth
            gap={8}
            className={cn(cls.AddNewAlbum, [classes])}
            // @ts-ignore
            onClick={(e: SyntheticEvent) => e.stopPropagation()}
        >
            {!isAdding ? (
                <UiButton
                    onClick={onAddingToggle}
                    startIcon={<Icon iconName="plus" />}
                    btnText={t('AddNewAlbum.return.AddNewAlbum.UiButton.btnText')}
                    variant="text"
                />
            ) : (
                <>
                    <Input
                        autoFocus
                        onValueChange={onInputChange}
                        value={addAlbumValue}
                        maxLength={40}
                        classes={[cls.input]}
                    />
                    <UiButton
                        onClick={() => addNewTag(addAlbumValue)}
                        btnText={t('button.save.text')}
                    />
                    <UiButton
                        onClick={onAddingToggle}
                        btnColor="secondary"
                        btnText={t('button.cancel.text')}
                    />
                </>
            )}
        </Flex>
    );
};
